var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_3645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_3645)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#FF2936"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H10.6667V0H0V20Z",
    fill: "#128415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.3333C12.5076 13.3333 14 11.8409 14 9.99998C14 8.15903 12.5076 6.66665 10.6667 6.66665C8.82572 6.66665 7.33333 8.15903 7.33333 9.99998C7.33333 11.8409 8.82572 13.3333 10.6667 13.3333Z",
    stroke: "#FAF94F",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33301 8.33333C9.33301 8.14924 9.48225 8 9.66634 8H11.6663C11.8504 8 11.9997 8.14924 11.9997 8.33333V10.6667C11.9997 11.403 11.4027 12 10.6663 12C9.92996 12 9.33301 11.403 9.33301 10.6667V8.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 10.6667C11.0349 10.6667 11.3333 9.70154 11.3333 9.33335C11.3333 8.96516 11.0349 8.66669 10.6667 8.66669C10.2985 8.66669 10 8.96516 10 9.33335C10 9.70154 10.2985 10.6667 10.6667 10.6667Z",
    fill: "#1D50B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.c684afcd51ff8cd9c83338ae5a4164aa.svg";
export { ForwardRef as ReactComponent };